// sagas.js
import {
  all,
  call,
  fork,
  put,
  take,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  fetchContactsSuccess,
  fetchContactsFailure,
  getUserDetail,
} from "./actions";
import CryptoJS from "crypto-js";

import apiServices from "../../services/apiServices";
import {
  FETCH_CONTACTS_REQUEST,
  IOS_PRV_MESSAGES,
  IOS_PRV_TYPING,
  ONLINE_USERS,
  SOCKET_CONNECT,
  SOCKET_DISCONNECT,
  USER_DETAIL,
} from "./actionTypes";
import { connectSocket, disconnectSocket } from "../../services/socketService";
import { eventChannel } from "redux-saga";
import { push } from "connected-react-router";
import axios from "axios";
import { sagaErrorHandler } from "../../Shared/HelperMethods/SagaErrorHandler";

const createSocketChannel = (socket) => {
  return eventChannel((emit) => {
    console.log("socket saga channel");

    socket.on("ios_prv_message", (data) => {
      emit({ type: IOS_PRV_MESSAGES, payload: data });
    });

    socket.on("ios_prv_typing", (data) => {
      emit({ type: IOS_PRV_TYPING, payload: data });
    });

    // socket.on("disconnect", () => {
    //   emit({ type: SOCKET_DISCONNECT });
    // });

    // Return a function to close the socket connection
    return () => {
      socket.off("message");
      socket.off("typing");
      socket.off("disconnect");
    };
  });
};

function* handleSocketConnection() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const socket = yield call(connectSocket, user?.id);
    const socketChannel = yield call(createSocketChannel, socket);

    // Fork the channel to listen for events emitted from the socket
    yield fork(function* () {
      while (true) {
        const action = yield take(socketChannel); // Take events from the channel
        console.log();
        yield put(action); // Dispatch events (messages, typing, etc.) to the Redux store
      }
    });
  } catch (err) {
    console.error("Socket connected error", err);
    yield put(push("/Aboutus"));
  }

  // Handle sending messages
  // yield takeEvery('SEND_MESSAGE', function* (action) {
  //   socket.emit('sendMessage', action.payload);  // Emit messages to the server
  // });
}

function* handleSocketClose() {
  yield call(disconnectSocket);
}

// Saga to handle fetching contacts
function* fetchContactsSaga(data) {
  try {
    const contacts = yield call(apiServices.getAllContacts, data.payload);
    console.log("contactsResponse??", contacts);
    yield put(fetchContactsSuccess(contacts.data));
  } catch (error) {
    console.log("error_contacts", error);
    yield put(fetchContactsFailure(error.message));
  }
}

function* getuserdetail({ payload }) {
  // const token = yield select(makeSelectAuthToken());
  console.log("enter profile saga", payload);
  try {
    // payload.setIsLoading(true);
    // Reload the window
    const useridlogin = payload.id;
    if (payload.setLoader) {
      payload.setLoader(true);
    }
    const encryptUserId = (userId) => {
      const base64Key = process.env.REACT_APP_BASE64_KEY;
      const base64Iv = process.env.REACT_APP_BASE64_KEY_IV;
      const key = CryptoJS.enc.Base64.parse(base64Key);
      const iv = CryptoJS.enc.Base64.parse(base64Iv);
      // Check if the key and IV have the correct length
      if (key.sigBytes !== 16 && key.sigBytes !== 24 && key.sigBytes !== 32) {
        throw new Error("Invalid key length. Expected 128, 192, or 256 bits.");
      }
      if (iv.sigBytes !== 16) {
        throw new Error("Invalid IV length. Expected 128 bits.");
      }
      const encrypted = CryptoJS.AES.encrypt(userId, key, { iv: iv });
      return encrypted.toString();
    };
    const encryptedId = encryptUserId(useridlogin.toString());
    const response = yield axios.get(
      `signup_svc/pv/users/getUserById?id=${useridlogin}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          userid: encryptedId,
        },
      }
    );
    console.log("encryption response:", response);
    yield put(getUserDetail(response.payload.Auth));
  } catch (error) {
    console.log("Encryption error:", error);
    yield sagaErrorHandler(error);
  } finally {
    if (payload.setLoader) {
      payload.setLoader(false);
    }
  }
}

// Watcher saga
export function* watchFetchContacts() {
  yield takeEvery(FETCH_CONTACTS_REQUEST, fetchContactsSaga);
}

export function* watchGetUserDetails() {
  yield takeEvery(USER_DETAIL, getuserdetail);
}

// export function* watchSocketConnection() {
//   yield takeLatest(SOCKET_CONNECT, handleSocketConnection);
// }

// export function* watchSocketDisconnectConnection() {
//   yield takeEvery(SOCKET_DISCONNECT, handleSocketClose);
// }

export default function* buzzcomSaga() {
  yield all([
    fork(watchFetchContacts),
    fork(watchGetUserDetails),
    // fork(watchSocketConnection),
    // fork(watchSocketDisconnectConnection),
  ]);
}
